import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// ----------------------------------Phase 2-----------------------------------------------

export const getAllAcademicYearByTeacher = async (idTeacher) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/teacher/yearall/${idTeacher}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

export const getAllCourseByTeacher = async (id_academicYear) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/course/cours/${id_academicYear}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};
